/**
 * Splits `text` into parts, marking case-insensitive occurrences of `query`
 * so templates can wrap matches (e.g. in <mark>) without v-html.
 * Used by the account-wide candidate search (ONE-6912) to highlight matches.
 */
export interface HighlightPart {
  text: string;
  isMatch: boolean;
}

export function splitTextForHighlight(text: string, query: string): HighlightPart[] {
  const trimmedQuery = query.trim();
  if (!text) return [];
  if (!trimmedQuery) return [{ text, isMatch: false }];

  const escapedQuery = trimmedQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const parts = text.split(new RegExp(`(${escapedQuery})`, 'ig'));

  return parts
    .filter((part) => part !== '')
    .map((part) => ({
      text: part,
      isMatch: part.toLowerCase() === trimmedQuery.toLowerCase(),
    }));
}
